export function stripe_key () {
    return process.env.VUE_APP_STRIPE_KEY
}